import {UserRoles} from "../../../user/user-roles";
import {TopbarButton} from "./topbar-button";
import {TypeUtils} from "../../utils/type-utils";

export class RouteData {

  public data: any;
  public url: string;
  public title: string;
  public pageId: string;
  public roles: string[];
  public hasMainSidebar: boolean;
  public hasMainHeader: boolean;
  public hasMainAiSidebar: boolean;
  public hasMainAiHeader: boolean;
  public hasSecondaryAiSidebar: boolean;
  public mainSidebarAutoCollapse: boolean;
  public hasSecondarySidebar: boolean;
  public hasTopBar: boolean;
  public hasNotificationsBanner: boolean;
  public reloadAfterActionsComplete: boolean;
  public guards: any[];
  public topbarButton: TopbarButton;
  public hasHostingOfferBanner: boolean;
  public hasTrialForInvitedBanner: boolean;
  public queryParams: any;

  constructor(
    data: any = {},
    url: string = '',
    queryParams: any = {},
    parseDynamicData: boolean = false
  ) {
    this.data = data;
    this.url = url;
    this.title = data.title || '';
    this.pageId = data.pageId || '';
    this.roles = data.roles || [UserRoles.user];
    this.hasMainSidebar = !TypeUtils.isUndefined(data.hasMainSidebar) ? data.hasMainSidebar : true;
    this.hasMainAiSidebar = !TypeUtils.isUndefined(data.hasMainAiSidebar) ? data.hasMainAiSidebar : false;
    this.hasMainHeader = !TypeUtils.isUndefined(data.hasMainHeader) ? data.hasMainHeader : true;
    this.hasMainAiHeader = !TypeUtils.isUndefined(data.hasMainAiHeader) ? data.hasMainAiHeader : false;
    this.hasSecondaryAiSidebar = !TypeUtils.isUndefined(data.hasSecondaryAiSidebar) ? data.hasSecondaryAiSidebar : false;
    this.mainSidebarAutoCollapse = !TypeUtils.isUndefined(data.mainSidebarAutoCollapse) ? data.mainSidebarAutoCollapse : true;
    this.hasNotificationsBanner = !TypeUtils.isUndefined(data.hasNotificationsBanner) ? data.hasNotificationsBanner : true;
    this.hasSecondarySidebar = !TypeUtils.isUndefined(data.hasSecondarySidebar) ? data.hasSecondarySidebar : true;
    this.hasTopBar = !TypeUtils.isUndefined(data.hasTopBar) ? data.hasTopBar : false;
    this.reloadAfterActionsComplete = !TypeUtils.isUndefined(data.reloadAfterActionsComplete) ? data.reloadAfterActionsComplete : true;
    this.guards = data.guards || [];
    this.topbarButton = data.topbarButton ? this.parseTopbarButton(data.topbarButton, url) : null;
    this.hasHostingOfferBanner = !TypeUtils.isUndefined(data.hasHostingOfferBanner) ? data.hasHostingOfferBanner : false;
    this.hasTrialForInvitedBanner = !TypeUtils.isUndefined(data.hasTrialForInvitedBanner) ? data.hasTrialForInvitedBanner : false;
    this.queryParams = queryParams || {};

    if (parseDynamicData) {
      if (data.dynamicTitle) {
        this.title = this.eval(data.dynamicTitle, data);
      }
    }
  }

  private parseTopbarButton(topbarButtonData: any, routeUrl: string): TopbarButton {
    const label: string = topbarButtonData.label;
    const linkLabel: string = topbarButtonData.linkLabel || "";
    let url: string;
    if (topbarButtonData.relativeUrl) {
      const routeParts: string[] = routeUrl.split('/');
      routeParts.pop();
      routeParts.push(topbarButtonData.relativeUrl);
      url = routeParts.join('/');
    }
    else {
      url = topbarButtonData.url;
    }

    return new TopbarButton(label, url, linkLabel);
  }

  private eval(keyChain: string, obj: object): any {
    const keys: string[] = keyChain.split('.');

    while (keys.length) {
      obj = obj[keys[0]];
      keys.shift();

      if (!obj) {
        break;
      }
    }

    return obj;
  }

}
